<script setup>
import { onMounted, watchEffect } from "vue"
import Feed from "../components/Feed"
import Loader from "../components/Loader.vue"
import FilterBar from "../components/FilterBar"
import { useFilteredFeedStore } from "../stores/FilteredFeed.js"

const store = useFilteredFeedStore()

onMounted(async () => {
  store.filters = await store.initState()

  watchEffect(() => {
    store.fetchItems()
  })
})

</script>
<template>
	<div>
		<FilterBar />

		<div class="min-h-[75vh]">
			<div class="py-24">
				<div class="container relative">
					<Transition>
						<Feed v-show="store.items.length && !store.isLoading" :items="store.items" />
					</Transition>
					<Transition>
						<p v-if="store.isLoading" class="absolute top-0">
							<Loader />
						</p>
					</Transition>
					<Transition>
						<p class="font-mono leading-tight text-md md:text-lg" v-if="!store.items.length && !store.isLoading">No results found, please change filters and try again.</p>
					</Transition>
				</div>
			</div>
		</div>
	</div>
</template>
<style>
.v-enter-active,
.v-leave-active {
	transition: opacity 0.33s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>